import store from '../store';
export default function (moduleName, module) {
    if (!store.hasModule(moduleName)) {
        store.registerModule(moduleName, module);
    }
}
